import {
    GET_OBSERVER,
    SET_OBSERVER_VOTERS,
} from './actionTypes';


const initState = {
    status: null,
    qvs: [],
    voters: []
};


const Observer = (state = initState, action) => {
    switch (action.type) {
        case GET_OBSERVER:
            return {
                ...state,
                status: action.payload.list_status.status,
                qvs: action.payload.qvs,
                voters: action.payload.voters
            }
        case SET_OBSERVER_VOTERS:
            return {
                ...state, 
                status: action.payload.list_status.status,
                qvs: action.payload.qvs,
                voters: action.payload.voters
            };
        default:
            return state;
    }
}


export default Observer